import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
import type { ViolationType } from './-query/type';
export const AlertTabKey = {
  SHADOW_IT: 'shadow-it',
  SHADOW_ID: 'shadow-id',
  SHADOW_AI: 'shadow-ai',
  DORMANT_IT: 'dormant-it',
  DORMANT_ID: 'dormant-id',
  DORMANT_AI: 'dormant-ai'
} as const;
export type AlertTabKey = (typeof AlertTabKey)[keyof typeof AlertTabKey];
export const AlertTabKeySchema = z.enum(['shadow-it', 'shadow-id', 'shadow-ai', 'dormant-it', 'dormant-id', 'dormant-ai']);
export const AlertColumnKey = {
  TRACEABLE_APP: 'traceableApp',
  CATEGORY: 'category',
  UNIQUE_USER_COUNT: 'uniqueUserCount',
  ACCESS_PERSONS: 'accessPersons',
  ACCESS_COUNT_7_DAYS: 'accessCount7Days',
  ACCESS_COUNT_30_DAYS: 'accessCount30Days',
  ACTION: 'action'
} as const;
export type AlertColumnKey = (typeof AlertColumnKey)[keyof typeof AlertColumnKey];
export const DormancyColumnKey = {
  SOFTWARE: 'software',
  ACTIVE_USER_COUNT: 'activeUserCount',
  DORMANT_COUNT: 'dormantCount',
  DORMANT_RATE: 'dormantRate',
  LAST_CALCULATED_AT: 'lastCalculatedAt',
  ACTION: 'action'
} as const;
export type DormancyColumnKey = (typeof DormancyColumnKey)[keyof typeof DormancyColumnKey];
export const AlertSearchSchema = z.object({
  alertTab: AlertTabKeySchema.default(AlertTabKey.SHADOW_IT),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  sortColumn: z.string().optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
  traceableAppIdIn: z.array(z.string()).optional(),
  categoryIn: z.array(z.string()).optional(),
  personIdIn: z.array(z.string()).optional(),
  softwareIds: z.array(z.string()).optional()
});
export type AlertSearchParams = z.infer<typeof AlertSearchSchema>;

/**
 * AlertTabKeyからViolationTypeへのマッピング
 */
export const alertTabKeyToViolationType = (tabKey: AlertTabKey): ViolationType => {
  switch (tabKey) {
    case AlertTabKey.SHADOW_IT:
      return 'SHADOW_ACCESS';
    case AlertTabKey.SHADOW_ID:
      return 'SHADOW_ID';
    default:
      return 'SHADOW_ACCESS';
  }
};